/* eslint-disable max-len */
import { Component, Input, OnInit, ElementRef, Inject } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { AngularFirestore } from '@angular/fire/firestore';
import { format, parseISO, getDate, getMonth, getYear } from 'date-fns';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-edit-about',
  templateUrl: './edit-about.component.html',
  styleUrls: ['./edit-about.component.scss'],
})
export class EditAboutComponent implements OnInit {

  @Input() public uid: any;
  currentUser = this.authService.currentUser;
  userForm;
  unsub1;
  constructor(
    public firestore: AngularFirestore,
    public modalCtrl: ModalController,
    public authService: AuthService,
    public formBuilder: FormBuilder,
    public toastController: ToastController,
    private el: ElementRef
  ) {

   }

  ngOnInit() { }

  async ionViewDidEnter() {
    console.log('ionViewDidEnter EditProfileComponent', this.uid);
    this.unsub1 = this.authService.currentAccount.subscribe(async (currentUser) => {  this.currentUser = currentUser; });
    this.userForm = this.formBuilder.group({
      about: [this.currentUser.about, [Validators.required]],
    });
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  get errorCtr1() {
    return this.userForm.controls;
  }

  calculateReferralCode(phoneNumber) {
    const x = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j'];
    const a = phoneNumber.slice(phoneNumber.length - 3, phoneNumber.length);
    const p = phoneNumber.slice(phoneNumber.length - 10, phoneNumber.length - 6);
    const pNumber = phoneNumber.slice(phoneNumber.length - 6, phoneNumber.length - 3);
    const alphabets = [x[a[0]], x[a[1]], x[a[2]]].reverse();
    const ranks = Array.from(p, num => Number(num)).map((v, i) => [v, i]).sort((l, b) => b[0] - l[0]).map((l, i) => [...l, i + 1]).sort((l, b) => a[1] - b[1]).map(l => a[2]);
    const indexes = [ranks.indexOf(4), ranks.indexOf(3), ranks.indexOf(2)];
    let referralCode = pNumber;
    for (let i = 0; i < alphabets.length; i++) {
      referralCode = [referralCode.slice(0, indexes[i]), alphabets[i], referralCode.slice(indexes[i])].join('');
    }
    return referralCode;
  }

  formatDate(value: string) {
    return format(parseISO(value), 'MMM dd yyyy');
  }


  save() {
    if (this.userForm.valid) {
      const data = this.userForm.getRawValue();
      console.log(data);
      const docRef = this.firestore.collection('accounts').doc(this.currentUser.id);
      // Atomically add a new region to the "regions" array field.
      docRef.update(data).then(() => {
        this.presentToast('Success', 'Profile updated successfully');
        this.closeModal();
      });
    } else {
      Object.keys(this.errorCtr1).forEach(key => {
        console.log(this.errorCtr1[key].valid);
        if (this.errorCtr1[key].valid === false) {
          this.presentToast(`Invalid ${key}`, `Please fill the ${key} Inputs provided!`);
          const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
          if (invalidControl) {
            setTimeout(() => {
              invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 2000);
            return;
          }
        }
      });
    }
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  async presentToast(header, message) {
    const toast = await this.toastController.create({
      header,
      message,
      position: 'middle',
      cssClass: 'spcl-toast',
      duration: 2000
    });
    await toast.present();

    const { role } = await toast.onDidDismiss();
    console.log('onDidDismiss resolved with role', role);
  }


  ionViewDidLeave() {
    this.unsub1.unsubscribe();
  }

}
